import SgdfDebouncedInput from './debounced-input.component.js';
export * from './debounced-input.component.js';
export default SgdfDebouncedInput;
SgdfDebouncedInput.define('sgdf-debounced-input');
//# sourceMappingURL=debounced-input.js.map